module.exports = __webpack_public_path__ + "static/media/foodshot3.afe7b8e6.JPG";